import React from "react";
import Container from "@material-ui/core/Container";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import List from "@material-ui/core/List";
import ListItemText from "@material-ui/core/ListItem";
import Link from "@material-ui/core/Link";
import Button from "@material-ui/core/Button";
import NavigateNext from "@material-ui/icons/NavigateNext";
import NavigateBefore from "@material-ui/icons/NavigateBefore";
import logo from "../assets/Colored/Logo Only/GIQ Colored Logo.png";
import { learningStylesData } from "../quiz/learningStylesData.js";
import socialVisual from "../assets/learningStyles/Social Visual Learner.png";
import socialLogical from "../assets/learningStyles/Social Logical Learner.png";
import socialPhysical from "../assets/learningStyles/Social Physical Learner.png";
import socialVerbal from "../assets/learningStyles/Social Verbal Learner.png";
import socialAuditory from "../assets/learningStyles/Social Auditory Learner.png";
import solitaryVisual from "../assets/learningStyles/Solitary Visual Learner.png";
import solitaryLogical from "../assets/learningStyles/Solitary Logical Learner.png";
import solitaryhysical from "../assets/learningStyles/Solitary Physical Learner.png";
import solitaryVerbal from "../assets/learningStyles/Solitary Verbal Learner.png";
import solitaryAuditory from "../assets/learningStyles/Solitary Auditory Learner.png";

const headers = {
  Visual: {
    Social: socialVisual,
    Solitary: solitaryVisual,
  },
  Physical: {
    Social: socialPhysical,
    Solitary: solitaryhysical,
  },
  Auditory: {
    Social: socialAuditory,
    Solitary: solitaryAuditory,
  },
  Verbal: {
    Social: socialVerbal,
    Solitary: solitaryVerbal,
  },
  Logical: {
    Social: socialLogical,
    Solitary: solitaryLogical,
  },
};

const styles = (theme) => ({
  root: {
    display: "flex",
    whiteSpace: "normal",
    width: "100%",
  },
});

class learningStylesHK extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPage: 0,
      selections: learningStylesData.qs.map((x) => ""),
      showSummary: false,
      summaryParam1: "",
      summaryParam2: "",
    };
  }

  onChange = (event) => {
    let s = this.state.selections;
    s[this.state.currentPage] = event.target.value;
    const page =
      this.state.currentPage === this.state.selections.length - 1
        ? this.state.currentPage
        : this.state.currentPage + 1;
    this.setState({ selections: s, currentPage: page });
  };

  handleNavigate = (event, direction) => {
    this.setState({ currentPage: this.state.currentPage + direction });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    var counts = {};
    for (let i = 0; i < this.state.selections.length; i++) {
      counts[this.state.selections[i]] =
        1 + (counts[this.state.selections[i]] || 0);
    }

    console.log(counts);

    // who should win in a tie?
    const param2 = counts["Social"] ? "Social" : "Solitary";

    delete counts["Social"];
    delete counts["Solitary"];

    console.log(Object.entries(counts));
    let max = 0;
    let param1 = "";
    for (const [key, value] of Object.entries(counts)) {
      if (value > max) {
        max = value;
        param1 = key;
      }
    }

    console.log("param1:" + param1);
    console.log("param2:" + param2);

    this.setState({
      showSummary: true,
      summaryParam1: param1,
      summaryParam2: param2,
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <Container maxWidth="xs">
        <br />
        <br />
        <center>
          <img src={logo} width={100} alt="logo" />
          <br />
          <br />
          <Typography variant="h4" component="h2">
            Growing IQ Learning Styles Assessment
          </Typography>
        </center>
        <br />
        {this.state.showSummary ? (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <img
                src={
                  headers[this.state.summaryParam1][this.state.summaryParam2]
                }
                alt="header"
                width="100%"
              />
            </Grid>
            <Grid item xs={12}>
              <Grid container justify="center" alignItems="center">
                <Typography variant="h6" component="h5">
                  {this.state.summaryParam2 +
                    " & " +
                    this.state.summaryParam1 +
                    " Learner"}
                  <br />
                </Typography>
                <Typography>
                  <br />
                  {
                    learningStylesData.s[this.state.summaryParam1][
                      this.state.summaryParam2
                    ].p1
                  }
                </Typography>
                <br />
                <Grid item xs={12}>
                  <Typography>
                    <br />
                    <b>Characteristics:</b>
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <List component="ol">
                    {learningStylesData.s[this.state.summaryParam1][
                      this.state.summaryParam2
                    ].cl.map((x, i) => (
                      <ListItemText key={"cl" + i}>
                        <Typography>{x}</Typography>
                      </ListItemText>
                    ))}
                  </List>
                </Grid>
                <Grid item xs={12}>
                  <Typography>
                    <b>
                      How Growing IQ benefits the{" "}
                      {this.state.summaryParam2.toLowerCase()} &{" "}
                      {this.state.summaryParam1.toLowerCase()} learner:
                    </b>
                    <br />
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <br />
                  <Typography>
                    {
                      learningStylesData.s[this.state.summaryParam1][
                        this.state.summaryParam2
                      ].p2
                    }
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <br />
                  <Typography>
                    {
                      learningStylesData.s[this.state.summaryParam1][
                        this.state.summaryParam2
                      ].p3
                    }
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <br />
                  <Grid container justify="center" alignItems="center">
                    <Typography>
                      <Link href="https://www.growingiq.com.hk/book-a-free-assessment">
                        Book a Free Trial
                      </Link>
                    </Typography>
                  </Grid>
                  <br />
                  <br />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        ) : (
          <Grid container spacing={1}>
            <Grid item xs={12} />

            <Grid item xs={12}>
              <Grid container justify="center" alignItems="center">
                <FormControlLabel
                  className={classes.root}
                  labelPlacement="top"
                  label={learningStylesData.qs[this.state.currentPage].q}
                  control={
                    <Select
                      autoWidth={true}
                      labelId="label"
                      id="select"
                      value={this.state.selections[this.state.currentPage]}
                      onChange={this.onChange}
                      className={classes.root}
                    >
                      {Object.entries(
                        learningStylesData.qs[this.state.currentPage].opts
                      ).map(([key, value]) => {
                        return (
                          <MenuItem
                            key={key}
                            value={value}
                            className={classes.root}
                          >
                            {key}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  }
                />
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid container alignItems="center" justify="center">
                <IconButton
                  onClick={(e) => this.handleNavigate(e, -1)}
                  disabled={this.state.currentPage === 0}
                >
                  <NavigateBefore />
                </IconButton>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={this.handleSubmit}
                  disabled={this.state.selections.includes("")}
                >
                  See Results
                </Button>
                <IconButton
                  onClick={(e) => this.handleNavigate(e, 1)}
                  disabled={
                    this.state.currentPage === this.state.selections.length - 1
                  }
                >
                  <NavigateNext />
                </IconButton>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Container>
    );
  }
}

learningStylesHK.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(learningStylesHK);
